module.exports = __webpack_public_path__ + "img/brodcast-nepa-summer-mobile.93c68550.jpg";